(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper')
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-template"]) return;
  try {
    
  (function () {
    var endlessScroll = null;
    var lastGrid = null;
    var isReinit = false;

    // ajaxinate.min.js is deferred and so is this bundle, so ordering is not
    // guaranteed. Poll for up to ~6s instead of giving up on the first miss.
    function whenAjaxinateReady(cb, tries) {
      tries = tries || 0;
      if (typeof Ajaxinate !== 'undefined') {
        cb();
        return;
      }
      if (tries > 60) return;
      setTimeout(function () {
        whenAjaxinateReady(cb, tries + 1);
      }, 100);
    }

    function teardownAjaxinate() {
      if (!endlessScroll) return;
      try {
        endlessScroll.destroy();
      } catch (e) {
        try {
          if (typeof endlessScroll.removeScrollListener === 'function') {
            endlessScroll.removeScrollListener();
          }
        } catch (e2) {}
      }
      endlessScroll = null;
    }

    function initAjaxinate() {
      lastGrid = document.getElementById('product-grid');
      teardownAjaxinate();

      var pagi = document.querySelector('.AjaxinatePagination');
      var loop = document.querySelector('.AjaxinateLoop');

      // No container, no grid, or no next-page link means nothing to bind.
      if (!pagi || !loop || !pagi.querySelector('a[href]')) return;

      var method = pagi.getAttribute('data-pagination') === 'scroll' ? 'scroll' : 'click';

      try {
        endlessScroll = new Ajaxinate({
          container: '.AjaxinateLoop',
          pagination: '.AjaxinatePagination',
          loadingText: '<span class="loader-line"></span>',
          method: method
        });
      } catch (e) {
        endlessScroll = null;
      }
    }

    function start() {
      var container = document.getElementById('ProductGridContainer');
      if (!container) return;

      // Numbered pagination mode: nothing to initialise, no observer needed.
      if (!document.querySelector('.AjaxinatePagination')) {
        lastGrid = document.getElementById('product-grid');
        return;
      }

      whenAjaxinateReady(function () {
        initAjaxinate();

        if (typeof MutationObserver === 'undefined') return;

        var observer = new MutationObserver(function () {
          if (isReinit) return;
          var currentGrid = document.getElementById('product-grid');
          // Only react when the grid node itself was replaced (filter/sort render).
          // Ajaxinate appends keep the same node, so this stays false for load-more.
          if (currentGrid && currentGrid !== lastGrid) {
            isReinit = true;
            initAjaxinate();
            // release the guard after the DOM settles
            setTimeout(function () { isReinit = false; }, 0);
          }
        });

        // Watch only direct children of the container, NOT the whole subtree.
        // The facet render replaces ProductGridContainer's child nodes;
        // Ajaxinate appends happen deeper inside the <ul>, so they won't fire this.
        observer.observe(container, { childList: true, subtree: false });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["parallax-banner"] && !Shopify.designMode) return;
  try {
    
class ParallaxImage extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const sectionId = this.getAttribute('section-id');
    const image = this.querySelector('img');
    const aosAnimation = this.getAttribute('data-aos');

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          window.addEventListener('scroll', this.parallaxEffect);
        } else {
          window.removeEventListener('scroll', this.parallaxEffect);
        }
      });
    });

    const section = document.getElementById(sectionId);
    observer.observe(section);

    const imageContainer = this;
    imageContainer.style.transform = 'translateY(0)';

    this.parallaxEffect = () => {
      const scrollPosition = window.pageYOffset;
      const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
      const parallaxValue = (scrollPosition / maxScroll) * 50;
      image.style.transform = `translateY(-${parallaxValue}%) scale(1.2)`;
    };
  }
}

customElements.define('parallax-image', ParallaxImage);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-content"]) return;
  try {
    
  class productPairs extends HTMLElement {
    connectedCallback() {
      fetch(this.dataset.url).
      then((response) => {
        if (!response.ok) {
          throw new Error("HTTP error! Status: ".concat(response.status));
        }
        return response.text();
      }).
      then((response) => {
        var frag = document.createDocumentFragment(),
          fetchedContent = document.createElement('div');
        frag.appendChild(fetchedContent);
        fetchedContent.innerHTML = response;

        var replacementContent = fetchedContent.querySelector("[data-id=\"".concat(CSS.escape(this.dataset.id), "\"]"));
        if (replacementContent) {
          this.innerHTML = replacementContent.innerHTML;
        }
      });
    }
  }

  customElements.define('product-pairs', productPairs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
 
class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
              const swiperContainer = this.querySelector('.swiper-container');
              const getID = swiperContainer.getAttribute("data-id");
              const swiperID = this.querySelector(`.swipercol-${getID}`);
              const spaceBetween = parseInt(swiperContainer.getAttribute('data-space-between'), 10);
              const perviewDesktop = swiperContainer.getAttribute('data-perview-desktop');
              if (swiperContainer) {
                new Swiper(swiperContainer, {
                  slidesPerView: "auto",
                  freeMode: false,
                  autoHeight: true,
                  calculateHeight:true,
                  freeModeSticky: true,
                  centeredSlides: false,
                  grabCursor: true,
                  watchSlidesVisibility: true,
                  watchSlidesProgress: true,
                  preloadImages: true,
                  updateOnImagesReady: true,
                  spaceBetween: spaceBetween,
                  observer: true,
                  observeParents: true,
                  parallax:true,
                  a11y: true,
                  keyboard: {
                    enabled: true,
                  },
                  breakpoints: {
                    320: {
                      slidesPerView: 2,
                      spaceBetween: 20
                    },
                    576: {
                      slidesPerView: 2,
                    },
                    768: {
                      slidesPerView: 3,
                    },
                    992: {
                      slidesPerView: perviewDesktop,
                    }
                  },
                  scrollbar: {
                    el: this.querySelector(".swiper-scrollbar"),
                  },
                  navigation: {
                    nextEl: this.querySelector(".swiper-button-next"),
                    prevEl: this.querySelector(".swiper-button-prev"),
                  },
                });
              } else {
                console.error('No element with class "swiper-container" found.');
              }

              // Initialize wishlist functionality after content loads
              initializeWishlistButtons();
            }
            if(typeof jdgm !== 'undefined'){
              jdgm.customizeBadges();
            }
            if (window.SPR && theme.review ) {
              if ($('.shopify-product-reviews-badge').length > 0) {
                return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
              };
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 500px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  // Wishlist Manager (same as product-list)
  const WishlistManager = {
    storageKey: 'shopify_wishlist',
    
    get: function() {
      try {
        return JSON.parse(localStorage.getItem(this.storageKey) || '[]');
      } catch (e) {
        console.error('Error reading wishlist:', e);
        return [];
      }
    },
    
    set: function(wishlist) {
      try {
        localStorage.setItem(this.storageKey, JSON.stringify(wishlist));
        this.updateCount();
        return true;
      } catch (e) {
        console.error('Error saving wishlist:', e);
        return false;
      }
    },
    
    add: function(productId) {
      let wishlist = this.get();
      if (!wishlist.includes(productId)) {
        wishlist.push(productId);
        this.set(wishlist);
        return true;
      }
      return false;
    },
    
    remove: function(productId) {
      let wishlist = this.get();
      const index = wishlist.indexOf(productId);
      if (index > -1) {
        wishlist.splice(index, 1);
        this.set(wishlist);
        return true;
      }
      return false;
    },
    
    has: function(productId) {
      return this.get().includes(productId);
    },
    
    updateCount: function() {
      const count = this.get().length;
      const countElements = document.querySelectorAll('.wishlist-count');
      countElements.forEach(el => {
        el.textContent = count;
        el.style.display = count > 0 ? 'block' : 'none';
      });
    }
  };

  // Show notification toast
  function showNotification(message, type) {
    const existingNotification = document.querySelector('.wishlist-notification');
    if (existingNotification) {
      existingNotification.remove();
    }
    
    const notification = document.createElement('div');
    notification.className = `wishlist-notification wishlist-notification--${type}`;
    
    const heartIcon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    heartIcon.setAttribute('viewBox', '0 0 24 24');
    heartIcon.setAttribute('class', 'notification-heart');
    
    const heartPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    heartPath.setAttribute('stroke-linecap', 'round');
    heartPath.setAttribute('stroke-linejoin', 'round');
    heartPath.setAttribute('d', 'M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12z');
    
    heartIcon.appendChild(heartPath);
    
    const textSpan = document.createElement('span');
    textSpan.textContent = message;
    
    notification.appendChild(heartIcon);
    notification.appendChild(textSpan);
    
    document.body.appendChild(notification);
    
    setTimeout(() => notification.classList.add('show'), 10);
    
    setTimeout(() => {
      notification.classList.remove('show');
      setTimeout(() => notification.remove(), 300);
    }, 3000);
  }

  // Initialize wishlist buttons
  function initializeWishlistButtons() {
    const wishlistBtns = document.querySelectorAll('.product-recommendations .wishlist-btn');
    
    wishlistBtns.forEach(btn => {
      const productId = btn.dataset.productId;
      
      if (productId && WishlistManager.has(productId)) {
        btn.classList.add('active');
      }
      
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        if (!productId) {
          console.warn('No product ID found');
          return;
        }
        
        const isActive = this.classList.contains('active');
        
        if (isActive) {
          if (WishlistManager.remove(productId)) {
            this.classList.remove('active');
            showNotification('Removed from wishlist', 'remove');
          }
        } else {
          if (WishlistManager.add(productId)) {
            this.classList.add('active');
            showNotification('Added to wishlist', 'add');
          }
        }
      });
    });
    
    WishlistManager.updateCount();
  }

  // Initialize on page load
  document.addEventListener('DOMContentLoaded', function() {
    initializeWishlistButtons();
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timeline"] && !Shopify.designMode) return;
  try {
    
  !function(){function e(e){this.element=e,this.blocks=this.element.getElementsByClassName("js-cd-block"),this.images=this.element.getElementsByClassName("js-cd-img"),this.contents=this.element.getElementsByClassName("js-cd-content"),this.offset=.8,this.hideBlocks()}e.prototype.hideBlocks=function(){if(!(!1 in document.documentElement))for(var e,t=this,s=0;s<this.blocks.length;s++)e=s,t.blocks[e].getBoundingClientRect().top>window.innerHeight*t.offset&&(t.images[e].classList.add("cd-is-hidden"),t.contents[e].classList.add("cd-is-hidden"))},e.prototype.showBlocks=function(){if(!(!1 in document.documentElement))for(var e,t=this,s=0;s<this.blocks.length;s++)e=s,t.contents[e].classList.contains("cd-is-hidden")&&t.blocks[e].getBoundingClientRect().top<=window.innerHeight*t.offset&&(t.images[e].classList.add("or-timeline__img--bounce-in"),t.contents[e].classList.add("or-timeline__content--bounce-in"),t.images[e].classList.remove("cd-is-hidden"),t.contents[e].classList.remove("cd-is-hidden"))};var t,s=document.getElementsByClassName("js-or-timeline"),n=[],i=!1;if(s.length>0){for(var o=0;o<s.length;o++)t=o,n.push(new e(s[t]));window.addEventListener("scroll",function(e){i||(i=!0,window.requestAnimationFrame?window.requestAnimationFrame(c):setTimeout(c,250))})}function c(){n.forEach(function(e){e.showBlocks()}),i=!1}}();

  } catch(e) { console.error(e); }
})();
})();
